import React from 'react';

// Barra de pestañas simple, en píldoras — mismo patrón visual ya usado
// (de forma manual, sin componente) en SGIPanel.jsx para sus tabs
// internos. `tabs` = [{ id, label, icon? }]. Controlado desde afuera
// (value/onChange), sin estado propio.
export function Tabs({ tabs, value, onChange, className = '' }) {
  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {tabs.map((tab) => {
        const active = value === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange(tab.id)}
            className={`px-4 py-2 rounded-full border text-sm font-medium inline-flex items-center gap-2 transition-all ${
              active
                ? 'text-white shadow-sm border-transparent'
                : 'bg-white border-gray-200 text-gray-700 hover:bg-gray-50 hover:shadow-sm'
            }`}
            style={active ? { background: 'linear-gradient(90deg, #2563EB 0%, #4F46E5 100%)' } : undefined}
          >
            {tab.icon ? <tab.icon size={16} /> : null}
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}

export default Tabs;
